import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Popover, Space } from "antd";
import { userSignOut } from "../../appRedux/actions/Auth";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

const UserProfile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ auth }) => auth);

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li
        onClick={() =>
          history.push(
            `/edit-profile`
          )
        }
      >
        Edit Profile
      </li>
      <li onClick={() => history.push("/edit-password")}>Ubah Password</li>
      <li onClick={() => history.push("/edit-2fa")}>Two-Factor Authentication</li>
      <li onClick={() => dispatch(userSignOut())}>Logout</li>
    </ul>
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
        className="gx-d-flex gx-align-items-center"
      >
        <Avatar
          className="gx-size-40 gx-pointer gx-mr-3 gx-d-flex gx-align-items-center gx-justify-content-center"
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="User / User_02">
                <path id="Vector" d="M20 21C20 18.2386 16.4183 16 12 16C7.58172 16 4 18.2386 4 21M12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
          }
        />
        <span className="gx-avatar-name">
          <Space direction="vertical" size={0}>
            <div>
              {authUser.name}
              <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
            </div>
            <div>{authUser.email}</div>
          </Space>
        </span>
      </Popover>
    </div>
  );
};

export default UserProfile;
